import { render, staticRenderFns } from "./page-aboutus-two.vue?vue&type=template&id=65267c6c&"
import script from "./page-aboutus-two.vue?vue&type=script&lang=js&"
export * from "./page-aboutus-two.vue?vue&type=script&lang=js&"
import style0 from "./page-aboutus-two.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports